import {
  CREATE_PAYMENT,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_ERROR,
} from '../actionTypes';

export const createPayment = (data) => ({
  type: CREATE_PAYMENT,
  payload: data,
});

export const createPaymentSuccess = (user) => ({
  type: CREATE_PAYMENT_SUCCESS,
  payload: user,
});

export const createPaymentError = (message) => ({
  type: CREATE_PAYMENT_ERROR,
  payload: message,
});
